import React from "react";
import "./SelectInput.css";
import Select from "react-select";
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const SelectInput = ({
  label,
  options,
  value,
  onSelect,
  noDataMessage = "no data..",
  maxMenuHeight = 200,
  isClearable = false,
  placeholder = "Select",
  parentClassName = "",
  selectClassName = "",
  labelClassName = "",
  parentStyle = {},
  selectStyle = {},
  labelStyle = {},
  customError,
  asterisk,
  disabled,
}) => {
  const flattenedOptions =
    options &&
    options?.reduce((acc, item) => {
      return acc.concat(item.options);
    }, []);

  return (
    <div
      div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-single-select-parent-class"
      }
      style={parentStyle}>
      <label
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-single-select-label-class"
        }
        style={labelStyle}>
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="input-wrapper">
        <Select
          value={value}
          onChange={onSelect}
          options={options}
          classNamePrefix="select2-selection"
          className={`${selectClassName} ${customError ? "input-error" : ""}`}
          placeholder={placeholder}
          styles={{
            ...selectStyle,
            control: (provided, state) => ({
              ...provided,
              borderColor: customError
                ? "#d15757"
                : state.isFocused
                ? "blue"
                : "#ccc",
              boxShadow: customError
                ? "0 0 3px rgba(255, 0, 0, 0.5) "
                : state.isFocused
                ? "0 0 0 1px blue"
                : "none",
              "&:hover": {
                borderColor: customError
                  ? "#d15757"
                  : state.isFocused
                  ? "blue"
                  : "#ccc",
              },
            }),
            menu: (provided) => ({
              ...provided,
              borderColor: "#ccc",
            }),
            option: (provided, state) => ({
              ...provided,

              padding: "10px",
              margin: "2px 8px",
              width: "calc(100% - 16px)",
              boxSizing: "border-box",
            }),

            placeholder: (provided) => ({
              ...provided,
              textTransform: "capitalize", 
            }),
          }}
          menuPortalTarget={document.body}
          noOptionsMessage={() => noDataMessage}
          maxMenuHeight={maxMenuHeight}
          isClearable={isClearable}
          isDisabled={disabled}
        />
        {customError && (
          <i className="fas fa-exclamation-circle error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default SelectInput;
